module.exports = __webpack_public_path__ + "static/woman-with-mask-store-trying-glasses-d794a112c88a42f818e12d9765450f20.png";